import React, { PropsWithChildren, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { AdminTopHeader } from "../components/AdminTopHeader";
import { useAdminAuth } from "./AdminAuthProvider";

/**
 * 관리자 전용 보호 라우트.
 * 비로그인 사용자를 로그인 페이지로 리다이렉트하고, 원래 경로를 next로 보존한다.
 */
export function AdminProtectedRoute({ children }: PropsWithChildren) {
  const { ready, user, error } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 로그인되지 않은 상태에서는 현재 경로를 보존한 채 로그인 화면으로 돌려보낸다.
    if (ready && !user) {
      const next = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?next=${next}`, { replace: true });
    }
  }, [location.pathname, location.search, navigate, ready, user]);

  if (!ready) {
    return (
      <div className="cm-shell">
        <AdminTopHeader />
        <main className="cm-protected-loader-wrap">
          <div className="cm-page-loader">Firebase 인증 상태를 확인하는 중입니다...</div>
        </main>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="cm-shell">
        <AdminTopHeader />
        <main className="cm-protected-loader-wrap">
          <div className="cm-page-loader">{error ? `인증 오류: ${error}` : "로그인 페이지로 이동 중입니다..."}</div>
        </main>
      </div>
    );
  }

  return <>{children}</>;
}
